import {Ionicons} from '@expo/vector-icons';
import React from 'react';

type Props = {
  isIncome: boolean;
  style?: any;
};

export const PaymentStatusIcon: React.FC<Props> = ({isIncome, style}) => {
  return (
    <Ionicons
      style={style}
      name={isIncome ? 'arrow-down-circle-outline' : 'arrow-up-circle-outline'}
    />
  );
};
